
<template>
  <div class="step">
    <div class="container"  v-if="hasTests">
      <ul v-bind:class="getActiveClass()" class="progressbar">
        <li>
          <span class="text">{{ lang != 'es' ? '1: Preencha o perfil' : '1: Rellena el perfil' }}</span>
          <span class="circle user"></span>
        </li>
        <li v-if="hasTests">
          <span class="text">{{ lang != 'es' ? '2: Faça os Testes' : '2: Toma las pruebas' }}</span>
          <span class="circle tests"></span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "StepProgress",

  props: {
    hasTests: {
      default: false,
    }
  },

  computed: {
    opportunityId() {
      const id = this.$route.params.id.match(/\d+/)[0];
      return id;
    },

    lang(){
      return localStorage.getItem('lang') || 'pt';
    }
  },

  methods: {
    getActiveClass() {
      let url = this.$router.history.current["path"];
      let step1 = `/vagas/${this.$route.params["id"]}/inscricao`;
      let step2 = `/vagas/${this.$route.params["id"]}/inscricao/testes`;
      let step3 = `/vagas/${
        this.$route.params["id"]
      }/inscricao/perguntas-adicionais`;
      if (url === step1) {
        return "step1";
      }
      if (url === step2) {
        return "step2";
      }
      if (url === step3) {
        return "step3";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/body{
  background-color: #f4f4f4;
}

.container {
  width: 100vw;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-top: 40px;
  @include media-breakpoint-down(md) {
    width: 100%;
  }
  .progressbar {
    width: 75%;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: baseline;
    padding: 0;
    margin: 0;
    @include media-breakpoint-down(md) {
      width: 100%;
      padding: 0;
    }
    li {
      list-style: none;
      display: flex;
      flex-direction: column;
      text-align: center;
      justify-content: space-around;
      width: 50%;
      height: 120px;
      white-space: normal;
      align-items: center;
      font-size: 12px;
      position: relative;
      .text {
        width: 80px;
      }
      @include media-breakpoint-down(md) {
        font-size: 11px;
      }
      &::after {
        content: "";
        position: absolute;
        width: 100%;
        height: 3px;
        background: theme-color('color-1');
        bottom: 50px;
        right: 55%;
        z-index: 0;
      }
      &:first-child{
        z-index: 1;
      }
      &:first-child:after {
        content: none;
      }
      .circle {
        position: relative;
        width: 45px;
        height: 45px;
        border: 2px solid theme-color('color-1');
        display: block;
        margin: 0 auto 25px auto;
        border-radius: 50%;
        line-height: 27px;
        background: white;
        color: #bebebe;
        text-align: center;
        font-weight: bold;
        background-repeat: no-repeat;
        background-position: center;
        z-index: 1;
      }
      .user {
        background-image: url("../assets/images/user.svg");
      }
      .tests {
        background-image: url("../assets/images/pen.svg");
      }
      .question {
        background-image: url("../assets/images/question.svg");
      }
    }
  }
  .step1 {
    li {
      &:first-of-type .circle {
        border: 2px solid theme-color-level("color-1");
        width: 45px;
        height: 45px;
      }
      &:first-of-type .text {
        font-weight: 700;
      }
    }
  }
  .step2 {
    li {
      &:first-of-type .circle {
        border: 2px solid theme-color-level("color-1");
        background-color: theme-color-level("color-1");
      }
      .user {
        background-image: url("../assets/images/user-white.svg");
      }
    }
    li:nth-child(2) {
      .circle {
        border: 2px solid theme-color-level("color-1");
        width: 45px;
        height: 45px;
      }
      .text {
        font-weight: 700;
      }
      &::after {
        content: "";
        background: theme-color-level("color-1");
      }
    }
  }
  .step3 {
    li:nth-child(1),
    li:nth-child(2) {
      .circle {
        border: 2px solid theme-color-level("green");
        background-color: theme-color-level("green");
      }
      &:first-child:after {
        content: none;
      }
      &::after {
        content: "";
        background: theme-color-level("green");
      }
      .user {
        background-image: url("../assets/images/user-white.svg");
      }
      .tests {
        background-image: url("../assets/images/pen-white.svg");
      }
    }
    li:nth-child(3) {
      .circle {
        border: 2px solid theme-color-level("color-1");
      }
      .text {
        font-weight: 700;
      }
    }
  }
}
</style>